(function(){
  function visibleHeaderLogo(){
    var nodes=Array.prototype.slice.call(document.querySelectorAll('.nilo-desktop-header-v51321__logo img,.header_logo img'));
    var best=null,bestScore=Infinity;
    nodes.forEach(function(n){var r=n.getBoundingClientRect();if(r.width<20||r.height<12||r.bottom<0||r.top>window.innerHeight)return;var score=Math.abs(r.top)+Math.abs((r.left+r.right)/2-window.innerWidth/2)*.05;if(score<bestScore){best=n;bestScore=score;}});
    return best;
  }
  function initSplash(){
    var splash=document.querySelector('[data-nilo-splash-v51319]');if(!splash||splash.hidden)return;
    var motion=splash.querySelector('[data-nilo-splash-logo]');if(!motion){splash.hidden=true;return;}
    try{sessionStorage.setItem('nilo_splash_v51319_seen','1');}catch(e){}
    splash.classList.add('is-running');
    var reduced=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function finish(){document.body.classList.add('nilo-splash-v51319-target-visible');splash.classList.add('is-finished');window.setTimeout(function(){splash.hidden=true;splash.classList.remove('is-running','is-docking','is-finished');document.body.classList.remove('nilo-splash-v51319-active','nilo-splash-v51319-target-visible');},reduced?80:260);}
    if(reduced){window.setTimeout(finish,180);return;}
    window.setTimeout(function(){
      var target=visibleHeaderLogo();
      if(!target){splash.classList.add('is-docking');window.setTimeout(finish,420);return;}
      var sr=motion.getBoundingClientRect(),tr=target.getBoundingClientRect();
      var dx=(tr.left+tr.width/2)-(sr.left+sr.width/2),dy=(tr.top+tr.height/2)-(sr.top+sr.height/2),scale=Math.max(.1,Math.min(1.2,tr.width/sr.width));
      motion.style.setProperty('--nilo-splash-dx',dx+'px');motion.style.setProperty('--nilo-splash-dy',dy+'px');motion.style.setProperty('--nilo-splash-scale',String(scale));
      splash.classList.add('is-docking');
      window.setTimeout(function(){document.body.classList.add('nilo-splash-v51319-target-visible');motion.classList.add('is-swapped');},610);
      window.setTimeout(finish,760);
    },980);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initSplash);else initSplash();
})();
